<template>
  <span
    class="text-primary-light relative uppercase sm:border border-primary-light inline-flex items-center text-xs rounded-full h-8"
    :key="$i18n.locale"
  >
    <span class="hidden sm:inline-block px-4 mr-8">{{$t('language')}}:</span>
    <span class="sm:hidden">&nbsp;</span>
    <ul
      class="langs-list absolute z-10 w-8 bg-primary-light rounded-full text-white"
    >
      <li
        class="lang-icon current"
        :class="$i18n.locale"
      >
        <img :src="require(`@/assets/flags/${$i18n.locale}.svg`)" :alt="$i18n.locale" />
      </li>
      <li
        v-for="lang in languages"
        :key="lang"
        class="lang-icon cursor-pointer"
        :class="lang"
        v-on:click="changeLang(lang)"
      >
        <img :src="require(`@/assets/flags/${lang}.svg`)" :alt="lang" />
      </li>
    </ul>
  </span>
</template>

<script>
import langs from "@/constants/langs.json";

export default {
  name: "LangSelect",

  computed: {
    languages() {
      return langs.filter(l => l !== this.$i18n.locale);
    }
  },

  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
      this.$router.replace({ name: this.$route.name, params: { ...this.$route.params, lang } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables";

.border-primary-light {
  border-color: rgba($colorLight, .25);
}

.lang-icon {
  padding: 7px;
  @apply .w-8;

  img {
    @apply .w-full;
  }
}

.langs-list {
  top: -1px;
  right: 0;

  .lang-icon:not(.current) {
    @apply .hidden;
  }

  &:hover .lang-icon {
    @apply .block;
  }
}
</style>
